import React from 'react';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import { setDash, setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import OpenUserDetail from '../../../../components/link/OpenUserDetail';
import Anchor from '../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';

/**
 *  포인트 랭킹 컬럼
 */
export const columns = (data) => {
  const { pointRankingList, sortOption, pageNum, pageSize, toggleModal } = data;

  return [
    {
      title: <TableColumnTitle title={'순위'} />,
      dataIndex: 'ranking',
      render: (value, record, index) => pageNum * pageSize + index + 1,
    },
    {
      title: <TableColumnTitle title={'유저 ID'} />,
      dataIndex: 'userId',
      render: (value) => <OpenUserDetail text={value} userId={value} />,
    },
    {
      title: <TableColumnTitle title={'유저명'} />,
      dataIndex: 'userName',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'친구 추천 코드'} />,
      dataIndex: 'referralCode',
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'현재 남아있는 포인트'} />,
      dataIndex: 'credit',
      sorter: true,
      sortOrder: sortOption['credit'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'누적 사용한 포인트'} />,
      dataIndex: 'usedCredit',
      sorter: true,
      sortOrder: sortOption['usedCredit'],
      render: (value, record, index) => (
        <Anchor
          color="primary"
          isUnderLine
          onClick={() =>
            toggleModal({
              name: 'pointLogModal',
              value: true,
              data: {
                userId: pointRankingList[index].userId,
              },
            })
          }
          text={setNumberWithComma(value)}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'기간 내 받은 포인트'} />,
      dataIndex: 'totalCredit',
      sorter: true,
      sortOrder: sortOption['totalCredit'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'기간 내 사용한 포인트'} />,
      dataIndex: 'totalUsedCredit',
      sorter: true,
      sortOrder: sortOption['totalUsedCredit'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'Point 생성일자'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'Point 업데이트일자'} />,
      dataIndex: 'updateDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};
